<template>
  <l-marker
    v-if="markerIcon&&show"
    :lat-lng="markerPosition"
    :icon="markerIcon"
    @click="onClick"
  >
    <l-tooltip :options="{permanent:this.$props.tooltips}">{{this.$props.sammelpunktObj.beschreibung}}</l-tooltip>
  </l-marker>
</template>

<script>
import { LMarker, LTooltip } from "@vue-leaflet/vue-leaflet";
import L from "leaflet";
import Swal from 'sweetalert2';

export default {
  name: "Sammelpunkt",
  components: { LMarker, LTooltip },
  props: {
    sammelpunktObj: Object,
    zoom: Number,
    markerPosition: Array,
    tooltips: Boolean,
    sammelpunkteBearbeiten: Boolean,
    sammelpunkteEntfernen: Boolean
  },
  data() {
    return {
      baseIconSize: 40, // Pixel bei Zoom 18
      markerIcon: L.icon({
        iconUrl: require("@/assets/KartenIcons/Sammelpunkte.png"),
        iconSize: [40, 40],
        iconAnchor: [20, 40],
        popupAnchor: [0, -20],
        tooltipAnchor: [0, -40]
      }),
      show: true
    };
  },
  methods: {
    createIcon(zoom) {
      const size = this.baseIconSize * Math.pow(2, (zoom - 18) * 0.5);
      return L.icon({
        iconUrl: require("@/assets/KartenIcons/Sammelpunkte.png"),
        iconSize: [size, size],
        iconAnchor: [size / 2, size],
        popupAnchor: [0, -size / 2],
        tooltipAnchor: [0, -size]
      });
    },
    onMapReady(map) {
      this.mapObject = map;
      map.invalidateSize();
    },
    onClick(){
      switch(true){
        case this.$props.sammelpunkteBearbeiten:
          this.$emit('sammelpunktBearbeiten', this.$props.sammelpunktObj);
          return;
        case this.$props.sammelpunkteEntfernen:
          this.$emit('sammelpunktEntfernen', this.$props.sammelpunktObj);
          return;
        default:
          var footerText = '<a href="https://www.google.com/maps/place/' + this.$props.sammelpunktObj.position.x + '+' + this.$props.sammelpunktObj.position.y + '" target="_blank" style="color: black !important; font-family: Helvetica, Arial, sans-serif !important; text-decoration: none !important">Zu Google Maps </a>';
          console.log(this.$props.sammelpunktObj);
          let titleText = this.$props.sammelpunktObj.beschreibung;
          Swal.fire({
              title: titleText,
              footer: footerText
          })
          break;
      }
    }
  },
  created() {
    this.markerIcon = this.createIcon(18);
  },
  mounted() {

  }
};
</script>

<style scoped>
.markerIcon{
    max-height: 2.5rem !important;
    filter: drop-shadow(0 0 0.05rem rgb(53, 53, 53));
}
</style>